import adminApi from './adminApi';

const ADMIN_TOKEN_KEY  = 'adminToken';
const ADMIN_USER_KEY   = 'adminUser';
const ADMIN_EXPIRY_KEY = 'adminSessionExpiry';
const SESSION_DURATION = 5 * 60 * 60 * 1000; // 5 hours

export const adminAuthService = {

  login: async (email, password) => {
    console.log('🔵 authService: login called');
    const response = await adminApi.login(email, password);
    console.log('🟢 authService: login response', response);

    if (response.success && response.token) {
      localStorage.setItem(ADMIN_TOKEN_KEY,  response.token);
      localStorage.setItem(ADMIN_USER_KEY,   JSON.stringify(response.user));
      localStorage.setItem(ADMIN_EXPIRY_KEY, (Date.now() + SESSION_DURATION).toString());
      console.log('🟢 authService: token saved to localStorage');
    }

    return response;
  },

  setup2FA: async (tempToken) => {
    return adminApi.setup2FA(tempToken);
  },

  verify2FA: async (tempToken, code) => {
    const response = await adminApi.verify2FA(tempToken, code);

    if (response.success && response.token) {
      localStorage.setItem(ADMIN_TOKEN_KEY,  response.token);
      localStorage.setItem(ADMIN_USER_KEY,   JSON.stringify(response.user));
      localStorage.setItem(ADMIN_EXPIRY_KEY, (Date.now() + SESSION_DURATION).toString());
    }

    return response;
  },

  logout: async () => {
    try {
      await adminApi.logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      adminAuthService.clearSession();
    }
  },

  forgotPassword: async (email) => {
    return adminApi.forgotPassword(email);
  },

  verifyOTP: async (email, otp) => {
    return adminApi.verifyOTP(email, otp);
  },

  resetPassword: async (resetToken, newPassword, confirmPassword) => {
    return adminApi.resetPassword(resetToken, newPassword, confirmPassword);
  },

  changePassword: async (currentPassword, newPassword, confirmPassword) => {
    return adminApi.changePassword(currentPassword, newPassword, confirmPassword);
  },

  isAuthenticated: () => {
    const token  = localStorage.getItem(ADMIN_TOKEN_KEY);
    const expiry = localStorage.getItem(ADMIN_EXPIRY_KEY);

    if (!token || !expiry) return false;

    if (Date.now() > parseInt(expiry)) {
      adminAuthService.clearSession();
      return false;
    }

    return true;
  },

  getCurrentUser: () => {
    try {
      const userStr = localStorage.getItem(ADMIN_USER_KEY);
      return userStr ? JSON.parse(userStr) : null;
    } catch {
      return null;
    }
  },

  getToken: () => localStorage.getItem(ADMIN_TOKEN_KEY),

  extendSession: () => {
    localStorage.setItem(ADMIN_EXPIRY_KEY, (Date.now() + SESSION_DURATION).toString());
  },

  getRemainingTime: () => {
    const expiry = localStorage.getItem(ADMIN_EXPIRY_KEY);
    if (!expiry) return 0;
    const remaining = parseInt(expiry) - Date.now();
    return remaining > 0 ? remaining : 0;
  },

  formatRemainingTime: () => {
    const remaining = adminAuthService.getRemainingTime();
    if (remaining <= 0) return '00:00';
    const minutes = Math.floor(remaining / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  },

  clearSession: () => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    localStorage.removeItem(ADMIN_USER_KEY);
    localStorage.removeItem(ADMIN_EXPIRY_KEY);
  },

  verifyToken: async () => {
    try {
      if (!localStorage.getItem(ADMIN_TOKEN_KEY)) return false;
      const response = await adminApi.verifyToken();
      return response.success;
    } catch {
      adminAuthService.clearSession();
      return false;
    }
  },
};

export default adminAuthService;

